import router from './index'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import config from '@/config/index'

const whiteList = config.whiteList // no redirect whitelist

const loadingSet = {
  state: false
}

NProgress.configure({ showSpinner: false }) // NProgress Configuration

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = to.meta.title

  // determine whether the user has logged in
  const hasToken = true;

  // const hasToken = getToken()  || 'gettoken'// todo

  console.log('hhh')

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      // 暂时不判断

      // 先查看是否有refresh_token,如果有的话，继续refresh一下
      next()
      // 暂时不判断
    }
  } else {
    if (hasBuffer) {
      await checkRefreshToken(hasBuffer, loadingSet)
    } else {
      if (whiteList.filter(o => o === to.path).length) {
        // in the free login whitelist, go directly
        next()
      } else {
        // other pages that do not have permission to access are redirected to the login page.
        next(`/login?redirect=${to.path}`)
        NProgress.done()
      }
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
